module.exports = __webpack_public_path__ + "static/media/CAMO_Banner.3802a1e3.png";